import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_7.jpg';

import Data_HoistingRigging from './Data_HoistingRigging';

function Work_HoistingRigging() {
    const canonical = 'https://studio.norcat.org/OurWork/hoisting-rigging';
    const title = 'Hoisting and Rigging | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Hoisting and Rigging is a VR training experience that helps learners build safe, repeatable high-risk lifting and rigging skills through immersive scenario-based practice.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Hoisting and Rigging VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Hoisting and Rigging VR training project"
            />
            <DetailedHeader
                heading="Training High-Risk Skills Without the Risk"
                client="NETCO / IBEW"
                service="Virtual Reality"
                date="2023"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=ITAigEsvANs"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Hoisting and Rigging project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Hoisting and Rigging project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Hoisting and Rigging project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Hoisting and Rigging project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Hoisting and Rigging project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'Hoisting and Rigging project screenshot 6',
                    },
                    {
                        image: projectImage7,
                        alt: 'Hoisting and Rigging project screenshot 7',
                    },
                ]}
            />

            {Data_HoistingRigging.content}
        </>
    );
}

export default Work_HoistingRigging;
